<div class="stack text-center">
  <dcr-animated-kai [src]="src" autoplay state="LOADING"></dcr-animated-kai>

  @if (showLabel) {
    <span class="label-large on-surface">{{ label }}</span>
  }
</div>
